import { API } from 'aws-amplify';

import { setList } from './checklistTemplatesSlice';
import store from '../../../../app/store';
import { listChecklists } from '../../../../graphql/queries';

export const getItems = async () => {
  try {
    let items = [];
    let token;
    do {
      const response = await API.graphql({
        query: listChecklists,
        variables: { limit: 2000, nextToken: token },
      });
      items = [...items, ...(response.data?.listChecklists?.items || [])];
      token = response.data?.listChecklists?.nextToken;
    } while (token);
    store.dispatch(setList(items));
  } catch (e) {
    console.log(e);
  }
};
